export enum WRiskAssessmentProperties {
  FILL_FROM_TRIGGER_AND_SELECT = 'FILL_FROM_TRIGGER_AND_SELECT',
  FILL_FROM_TRIGGER = 'FILL_FROM_TRIGGER',
  FILL_FROM_QUERY = 'FILL_FROM_QUERY'
}
